'use client';

import { useEffect } from 'react';
import { CONSENT_EVENT, hasFullConsent } from '@/lib/attribution';
import { loadGoogleTag, unloadGoogleTag } from '@/lib/google-tag';

/**
 * Renders nothing. Loads the Google tag (GA4 + Google Ads) only while the
 * visitor's banner choice is 'full', and reacts to a later accept/withdraw
 * (CONSENT_EVENT from onConsentChange, or another tab via the storage event)
 * without a reload. See lib/google-tag.ts.
 *
 * It is a client component rather than the server-rendered <Script>s it
 * replaced because the root layout must stay static: the consent value lives
 * in localStorage, which only the browser can read.
 */
export function TrackingScripts() {
  useEffect(() => {
    const ids = {
      ga4Id: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
      adsId: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID,
    };
    const sync = () => (hasFullConsent() ? loadGoogleTag(ids) : unloadGoogleTag());
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CONSENT_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return null;
}
